
export default {
  props: {
    title: ""
  }
};
